var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{staticClass:"row justify-center"},[_c('q-inner-loading',{attrs:{"showing":true}},[_c('q-spinner-hourglass',{attrs:{"color":"primary","size":"2em"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }